import React from "react";
import Sidebar from "../components/Sidebar";
import { useMobileStatus } from "../hooks/useMobileStatus";
import MobileHeader from "../components/MobileHeader";
import AdminCardEditor from "../components/AdminCardEditor";

const AdminPage = () => {
  const isMobile = useMobileStatus();

  return (
    <>
      {!isMobile && <Sidebar />}
      <div className="container-main container-big">
        {isMobile && <MobileHeader />}
        <AdminCardEditor />
      </div>
    </>
  );
};

export default AdminPage;
